import React from 'react'
import { Box, Typography, makeStyles, Theme } from '@material-ui/core'
import AddIcon from '@material-ui/icons/Add'
import BusinessIcon from '@material-ui/icons/Business'
import LibraryBooksIcon from '@material-ui/icons/LibraryBooks'

import {
    SECTION_TONES,
    SetupOriginInfo,
    SetupOriginLane,
} from './setupChooserTones'

const useStyles = makeStyles((theme: Theme) => ({
    root: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: theme.spacing(0.75),
        minWidth: 0,
        maxWidth: '100%',
    },
    iconWrap: {
        flexShrink: 0,
        width: 22,
        height: 22,
        borderRadius: 6,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    label: {
        fontSize: '0.8125rem',
        lineHeight: 1.35,
        color: theme.palette.text.secondary,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
    },
    labelCompact: {
        fontSize: '0.75rem',
    },
}))

function OriginIcon({ lane }: { lane: SetupOriginLane }) {
    const style = { fontSize: 14 }
    switch (lane) {
        case 'org':
            return <BusinessIcon style={style} />
        case 'ezos':
            return <LibraryBooksIcon style={style} />
        case 'scratch':
            return <AddIcon style={style} />
        default:
            return <AddIcon style={style} />
    }
}

/** Icon + source name — mirrors chooser lane identity without prose. */
export const SetupOriginLine: React.FC<{
    origin: SetupOriginInfo
    compact?: boolean
}> = ({ origin, compact = false }) => {
    const classes = useStyles()
    const tone = SECTION_TONES[origin.lane]

    return (
        <Box className={classes.root} title={origin.label}>
            <Box
                className={classes.iconWrap}
                style={{
                    backgroundColor: tone.iconBg,
                    color: tone.iconColor,
                }}
            >
                <OriginIcon lane={origin.lane} />
            </Box>
            <Typography
                className={`${classes.label}${
                    compact ? ` ${classes.labelCompact}` : ''
                }`}
            >
                {origin.label}
            </Typography>
        </Box>
    )
}
